import { BrandWebService, RestfulBrandWebService } from 'ws/BrandWebService';
import { BrandOption, CnCodeOption, OutBoundKeyword, OutBound } from './Brand';

export interface BrandManager {
  getBrandOptions(): Promise<BrandOption[]>;
  getCnCodeOptions(webBrandNo: string): Promise<CnCodeOption[]>;
  getMaxCvrBrandOptions(): Promise<BrandOption[]>;
  getRecommendBrandOptions(): Promise<BrandOption[]>;
  getOutBoundKeywordBrand(): Promise<OutBoundKeyword[]>;
}

export interface Iprops {
  campaignAdType: string;
  goodsId: string;
}

export class DefaultBrandManager implements BrandManager {
  webService: BrandWebService;

  constructor(webService: BrandWebService = new RestfulBrandWebService()) {
    this.webService = webService;
  }

  async getBrandOptions(): Promise<BrandOption[]> {
    return this.webService.getBrandOptions();
  }
  async getOutSideBrands(props: Iprops): Promise<OutBound[]> {
    return this.webService.getOutSideBrands(props);
  }

  async getCnCodeOptions(webBrandNo: string): Promise<CnCodeOption[]> {
    return this.webService.getCnCodeOptions(webBrandNo);
  }

  async getMaxCvrBrandOptions(): Promise<BrandOption[]> {
    return this.webService.getMaxCvrBrandOptions();
  }

  async getRecommendBrandOptions(): Promise<BrandOption[]> {
    return this.webService.getRecommendBrandOptions();
  }
  async getOutBoundKeywordBrand(): Promise<OutBoundKeyword[]> {
    return this.webService.getOutBoundKeywordBrand();
  }
}
